import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import toast from 'react-hot-toast'

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { verifyEmail } = useAuthStore()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) {
      setError('This verification link is missing a token.')
      return
    }
    verifyEmail(token)
      .then((result) => {
        toast.success('Email verified')
        navigate(result.requires_payment_setup ? '/billing' : '/dashboard', { replace: true })
      })
      .catch((err: any) => {
        const payload = err.response?.data
        setError(
          (payload && typeof payload === 'object' && payload.message) ||
            (typeof payload === 'string' ? payload : null) ||
            'This verification link is invalid or expired.'
        )
      })
  }, [searchParams, verifyEmail, navigate])

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
        <div className="max-w-md w-full bg-white shadow rounded-lg p-8 text-center">
          <h1 className="text-2xl font-bold text-gray-900">Could not verify email</h1>
          <p className="mt-3 text-sm text-gray-600">{error}</p>
          <Link to="/login" className="mt-6 inline-block text-primary-600 font-medium">
            Back to sign in
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <p className="text-gray-600">Verifying your email…</p>
    </div>
  )
}
